<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Tilbud" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
					<employee-select-view v-model="entity" label="Ansvarlig" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Status" v-model="entity.status" :options="status" :optional="true" optionValueName="name" />
				</div>
				<div v-show="active == 'details'">
					<date-select-view label="Udløbsdato" v-model="entity.valid_to" :controller="$store.state.popupController" />
				</div>
				<div v-show="active == 'details'">
					<date-select-view label="Næste kontakt" v-model="entity.next_contact" :controller="$store.state.popupController" :optional="true" />
				</div>
				<div v-show="active == 'hmm'">
					<text-view label="Tekst før pris" v-model="entity.description" :height="180" :optional="true" />
				</div>
				<div v-show="active == 'hmm'">
					<text-view label="Tekst efter pris" v-model="entity.comments" :height="180" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<text-view label="Bemærkninger (administrationen)" v-model="entity.remarks" :height="250" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<text-view label="Bemærkninger (alle)" v-model="entity.remarks_all" :height="250" :optional="true" />
				</div>
				<div v-show="active == 'customer' && entity._embedded.contact.details && entity._embedded.contact.details != ''">
					<info-view>{{ entity._embedded.contact.details }}</info-view>
				</div>
				<div v-show="active == 'customer'">
					<contact-select-view v-model="entity" label="Kunde" :optional="true" @select="selectCustomer" />
				</div>
				<div v-show="active == 'customer'">
					<string-view label="Telefon" v-model="entity.customer.phone" :optional="true" />
					<string-view label="E-mail" v-model="entity.customer.email" :optional="true" />
				</div>
				<div v-show="active == 'customer'">
					<string-view label="Navn" v-model="entity.customer.name" />
					<string-view label="Att." v-model="entity.customer.att" :optional="true" />
				</div>
				<address-view v-show="active == 'customer'" v-model="entity.customer.address" />
				<div v-show="active == 'customer'">
					<string-view v-for="(number, i) in _numbers" :label="number.label" v-model="entity.customer.numbers[number.name]" :key="i" :optional="true" />
				</div>
				<div v-show="active == 'order'">
					<order-view :altPrices="this.prices" v-model="entity.order_lines" />
				</div>
				<div v-show="active == 'template'">
					<select-view label="Skabelon" v-model="entity.template_id" :options="templates" optionValueName="id" />
				</div>
				<div v-show="active == 'template'">
					<string-view label="Opbevaring" v-model="entity.template.storage" />
					<div class="side-window__heading">
						Vis med moms
						<switch-view v-model="entity.template.storage_vat" />
					</div>
				</div>
				<div v-show="active == 'template'">
					<div v-for="(line, i) in _lines" :key="i" class="side-window__heading" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 50px;" :title="line">
						{{ line }}
						<switch-view :value="entity.template.incl.includes(line)" @input="inclInput($event, line)" />
					</div>
				</div>
				<div v-show="active == 'template'">
					<text-view label="Evt. andet" v-model="entity.template.extra" :height="180" :optional="true" />
				</div>
				<div v-show="active == 'template' && _template && _template.ps_editable">
					<text-view label="Efterskrift" v-model="entity.template.ps" :height="180" :optional="true" />
				</div>
				<div v-show="active == 'tasks'">
					<task-list-view v-model="entity._embedded.tasks" :template="{
						department_id: entity.department_id,
						contact_id: entity.contact_id,
						employee_id: entity.employee_id,
						name: entity.customer.name,
						email: entity.customer.email,
						phone: entity.customer.phone,
						details: {
							address: entity.customer.address,
							route: [
								{
									address: 	entity.customer.address.address,
									zip: 		entity.customer.address.zip,
									city: 		entity.customer.address.city,
									country: 	entity.customer.address.country
								}
							]
						},
						_embedded: {
							employee: entity._embedded.employee,
							contact: entity._embedded.contact
						}
					}" :mask="['move', 'courier']" />
				</div>
				<div v-show="active == 'files'">
					<file-list-view v-model="entity.files" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import ContactSelectView from '../views/ContactSelectView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import TaskListView from '../views/TaskListView';
	import AddressView from '../views/AddressView';

	import QuoteModel from '../model/Quote'
	import ContactModel from '../model/Contact'

	import merge from '../functions/merge'

	export default {
		data: function () {
			return {
				//packaging: [],
				//ORDER: [],
				entity: {},
				


				prices: [],
				active: 'details',
				//instructions: [],
				departments: [],
				staticNumbers: [
					{
						name: 'vat',
						label: 'CVR',
						default: ''
					},
					{
						name: 'ean',
						label: 'EAN',
						default: ''
					}
				],
				numbers: [],
				status: [],
				templates: []
				//motivations: [],
				//tasks: []
			};
		},
		watch: {
			from(newVal) {
				this.to = newVal;
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'ContactSelectView': ContactSelectView,
			'TaskListView': TaskListView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'customer',
						label: 'Kunde'
					},
					{
						name: 'order',
						label: 'Pris'
					},
					{
						name: 'template',
						label: 'Udskrift'
					},
					{
						name: 'tasks',
						label: 'Opgaver'
					},
					{
						name: 'files',
						label: 'Filer'
					}
				];
			},
			_template() {
				var self = this;
				return this.templates.find(function (item) { return item.id == self.entity.template_id; });
			},
			_lines() {
				return this._template ? this._template.incl.split("\n") : [];
			},
			_numbers() {
				var r = [];
				var i;

				for (i = 0; i < this.staticNumbers.length; ++i) {
					r.push(this.staticNumbers[i]);
				}

				for (i = 0; i < this.numbers.length; ++i) {
					r.push(this.numbers[i]);
				}

				// Add to entity
				var ent = this.entity;
				
				for (i = 0; i < r.length; ++i) {
					if (!ent.customer.numbers.hasOwnProperty(r[i].name)) {
						ent.customer.numbers[r[i].label] = r[i].default;
					}
				}

				

				return r;
			}
		},
		props: {
			value: {
				type: Object,
				default() {
					return merge({}, QuoteModel.entity());
				}
			},

			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function (entity) { return true; }
			},
			/*entity: {
				type: Object,
				default() {
					return merge({}, QuoteModel.entity);
				}
			},*/
			lookup: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			inclInput(val, line) {
				if (val) {
					this.entity.template.incl.push(line);
				} else {
					this.entity.template.incl.splice(this.entity.template.incl.indexOf(line), 1);
				}
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(merge({}, this.entity));
			},
			selectCustomer(obj) {
				
				this.numbers = [];

				for (var i = 0; i < obj.numbers.length; ++i) {
					this.numbers.push({
						name: 		obj.numbers[i].label,
						label: 		obj.numbers[i].label,
						default: 	obj.numbers[i].static ? obj.numbers[i].entity : ''
					});
				}

				

				this.entity = merge(this.entity, {
					customer: {
						name: obj.name,
						address: {
							address: 	obj.address,
							zip: 		obj.zip,
							city: 		obj.city,
							country: 	obj.country
						},
						phone: obj.phone,
						email: obj.email,
						numbers: {
							vat:		obj.roles.business.vat,
							ean:		obj.roles.business.ean
						}
					}
				});

				//this.$emit('input', n);

				//

				this.prices = obj._embedded.prices;

				
			},
			printEnt() {
				

				setTimeout(this.printEnt, 2000);
			}
		},
		mounted: async function() {
			//

			var self = this;

			this.entity = merge(QuoteModel.entity(), this.value);

			

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/sales/quotes/status/')
				.then(function (r) {
					self.status = r.data._items;
				});

			this.axios
				.get('/templates/quotes/')
				.then(function (r) {
					self.templates = r.data._items;
				});

			//

			if (this.lookup && this.entity.contact_id !== null) {
				var obj = await ContactModel.read(this.axios, this.entity.contact_id);

				

				this.entity = merge(this.entity, {
					customer: {
						name: obj.name,
						address: {
							address: 	obj.address,
							zip: 		obj.zip,
							city: 		obj.city,
							country: 	obj.country
						},
						phone: obj.phone,
						email: obj.email,
						numbers: {
							vat:		obj.roles.hasOwnProperty('business') ? obj.roles.business.vat : '',
							ean:		obj.roles.hasOwnProperty('business') ? obj.roles.business.ean : '',
						}
					}
				});
			}

			this.printEnt();


			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
